export const reminders: { key: string; friendlyLabel: string; numberOfDays: number }[] = [];

for (let i = 1; i < 30; i++) {
  reminders.push({
    key: `${i}dayBefore`,
    friendlyLabel: `Day Before Expiration`,
    numberOfDays: i
  });
}

// export const reminderSelectionKeys = [1, 2];
export const reminderSelectionKeys = [
  { id: 1, name: 'First Reminder' },
  { id: 2, name: 'Second Reminder', previousId: 1 }
];
